<div class="insights-container">
    <!-- Header Section -->
    <div class="insights-header">
        <div class="header-content">
            <div class="header-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                </svg>
            </div>
            <div class="header-text">
                <h1 class="page-title">Voucher Insights</h1>
                <p class="page-subtitle">Overview of your voucher statistics and performance</p>
            </div>
        </div>

        <div class="header-actions">
            <!-- Filter Section -->
            <div class="insights-filters">
                <div class="filter-group">
                    <label for="fromDate">From Date</label>
                    <input type="date" id="fromDate" [(ngModel)]="fromDate" class="filter-input"
                        (change)="loadInsights()">
                </div>
                <div class="filter-group">
                    <label for="toDate">To Date</label>
                    <input type="date" id="toDate" [(ngModel)]="toDate" class="filter-input" (change)="loadInsights()">
                </div>
                <div class="filter-actions" *ngIf="fromDate || toDate">
                    <button class="btn-clear" (click)="fromDate = undefined; toDate = undefined; loadInsights()">
                        Clear
                    </button>
                </div>
            </div>

            <button class="btn-refresh" (click)="loadInsights()" [disabled]="isLoading">
                <i class="fas fa-sync-alt" [class.fa-spin]="isLoading"></i>
                Refresh
            </button>
        </div>
    </div>

    <!-- Loading State -->
    <div class="loading-section" *ngIf="isLoading">
        <div class="loading-spinner"></div>
        <p class="loading-text">Loading insights...</p>
    </div>

    <!-- Error Message -->
    <div class="error-message" *ngIf="errorMessage && !isLoading">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <span>{{ errorMessage }}</span>
    </div>

    <!-- Statistics Cards -->
    <div class="stats-grid" *ngIf="!isLoading && !errorMessage">
        <!-- Total Vouchers -->
        <div class="stat-card stat-total">
            <div class="stat-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z" />
                </svg>
            </div>
            <div class="stat-content">
                <p class="stat-label">Total Vouchers</p>
                <p class="stat-value">{{ stats.totalVouchers }}</p>
            </div>
        </div>

        <!-- Active Vouchers -->
        <div class="stat-card stat-active">
            <div class="stat-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
            </div>
            <div class="stat-content">
                <p class="stat-label">Active</p>
                <p class="stat-value">{{ stats.totalActiveVouchers }}</p>
            </div>
        </div>

        <!-- Redeemed Vouchers -->
        <div class="stat-card stat-redeemed">
            <div class="stat-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
            </div>
            <div class="stat-content">
                <p class="stat-label">Redeemed</p>
                <p class="stat-value">{{ stats.totalRedeemedVouchers }}</p>
            </div>
        </div>

        <!-- Expired Vouchers -->
        <div class="stat-card stat-expired">
            <div class="stat-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
            </div>
            <div class="stat-content">
                <p class="stat-label">Expired</p>
                <p class="stat-value">{{ stats.totalExpiredVouchers }}</p>
            </div>
        </div>

        <!-- Cancelled Vouchers -->
        <div class="stat-card stat-cancelled">
            <div class="stat-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
            </div>
            <div class="stat-content">
                <p class="stat-label">Cancelled</p>
                <p class="stat-value">{{ stats.totalCancelledVouchers }}</p>
            </div>
        </div>

        <!-- Revoked Vouchers -->
        <div class="stat-card stat-revoked">
            <div class="stat-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
                </svg>
            </div>
            <div class="stat-content">
                <p class="stat-label">Revoked</p>
                <p class="stat-value">{{ stats.totalRevokedVouchers }}</p>
            </div>
        </div>

        <!-- Total Voucher Amount -->
        <div class="stat-card stat-amount">
            <div class="stat-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
            </div>
            <div class="stat-content">
                <p class="stat-label">Total Voucher Amount</p>
                <p class="stat-value">₹{{ stats.totalVoucherAmount | number:'1.2-2' }}</p>
            </div>
        </div>

        <!-- Total Redeemed Amount -->
        <div class="stat-card stat-redeemed-amount">
            <div class="stat-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
            </div>
            <div class="stat-content">
                <p class="stat-label">Total Redeemed Amount</p>
                <p class="stat-value">₹{{ stats.totalRedeemedAmount | number:'1.2-2' }}</p>
            </div>
        </div>

        <!-- Total Min Purchase Amount -->
        <div class="stat-card stat-min-purchase">
            <div class="stat-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                </svg>
            </div>
            <div class="stat-content">
                <p class="stat-label">Total Min Purchase</p>
                <p class="stat-value">₹{{ stats.totalMinPurchaseAmount | number:'1.2-2' }}</p>
            </div>
        </div>
    </div>
</div>